var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNullable, IsUndefinable, IsUUIDWithLVS, LengthWithLVS, TransformWithLVS } from '@goparrot/common';
import { ApiExtraModels, ApiProperty, ApiPropertyOptional } from '@nestjs/swagger-v4';
import { Expose, Type } from 'class-transformer';
import { Allow, ArrayNotEmpty, IsArray, IsBoolean, IsDate, IsNotEmpty, IsNumber, IsOptional, IsString, Min, ValidateNested } from 'class-validator';
import { DateTime } from 'luxon';
import { CampaignExposeGroup, CampaignStateEnum, CampaignStatusEnum } from '../interface';
import { ReadCampaignCohortConfigDto } from './ReadCampaignCohortConfigDto';
import { ReadCampaignSenderDetailsDto } from './ReadCampaignSenderDetailsDto';
import { ReadCampaignWorkflowConfigDto } from './ReadCampaignWorkflowConfigDto';
let ReadCampaignDto = class ReadCampaignDto {
};
__decorate([
    ApiProperty({ type: () => String, format: 'uuid', description: 'uuid v4', example: 'e12acc6f-2f34-442c-92d3-d4199fb12345' }),
    Expose({ groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ] }),
    Allow({ always: true }),
    __metadata("design:type", String)
], ReadCampaignDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ type: () => String, format: 'uuid', description: 'uuid v4', example: 'e12acc6f-2f34-442c-92d3-d4199fb12345' }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    IsUndefinable({ groups: [CampaignExposeGroup.UPDATE] }),
    IsUUIDWithLVS('4', { groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START], message: 'Please select a template' }),
    __metadata("design:type", String)
], ReadCampaignDto.prototype, "campaignTemplateId", void 0);
__decorate([
    ApiProperty({ description: 'Notifier custom configuration.', type: () => ReadCampaignSenderDetailsDto }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    Type(() => ReadCampaignSenderDetailsDto),
    ValidateNested({ always: true }),
    IsOptional({ groups: [CampaignExposeGroup.UPDATE] }),
    __metadata("design:type", ReadCampaignSenderDetailsDto)
], ReadCampaignDto.prototype, "senderDetails", void 0);
__decorate([
    ApiProperty({ description: 'Cohort config.', type: () => ReadCampaignCohortConfigDto }),
    Expose({
        groups: [
            CampaignExposeGroup.MODEL,
            CampaignExposeGroup.READ,
            CampaignExposeGroup.CREATE,
            CampaignExposeGroup.UPDATE,
            CampaignExposeGroup.CONFIG,
            CampaignExposeGroup.START,
        ],
    }),
    Type(() => ReadCampaignCohortConfigDto),
    IsUndefinable({ groups: [CampaignExposeGroup.UPDATE] }),
    IsNotEmpty({ groups: [CampaignExposeGroup.START] }),
    ValidateNested({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    __metadata("design:type", ReadCampaignCohortConfigDto)
], ReadCampaignDto.prototype, "cohort", void 0);
__decorate([
    ApiProperty({ description: 'ref to merchant.merchantId', example: 'ddfb5654-7fe1-40de-8be8-041116c8f267', type: () => String }),
    Expose({ groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ] }),
    Allow({ always: true }),
    __metadata("design:type", String)
], ReadCampaignDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ description: 'Title of campaign.', example: 'Miss you campaign', type: () => String }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    IsUndefinable({ groups: [CampaignExposeGroup.UPDATE] }),
    IsNotEmpty({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.START], message: 'Please enter a name for your campaign' }),
    IsString({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    LengthWithLVS(3, 255, {
        groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
        message: 'The campaign title must be equal or longer than $constraint1 characters.',
    }),
    __metadata("design:type", String)
], ReadCampaignDto.prototype, "title", void 0);
__decorate([
    ApiProperty({
        description: 'Description of campaign.',
        example: "This campaign must to remind users that they didn't order for a while.",
        type: () => String,
        nullable: true,
    }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    IsUndefinable({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    IsString({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    IsNullable({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    LengthWithLVS(3, 255, { groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    __metadata("design:type", Object)
], ReadCampaignDto.prototype, "description", void 0);
__decorate([
    ApiPropertyOptional({ description: 'Store ID list.', example: ['32d5c049-3c15-41e2-9d7b-313317d22be6'], type: () => String, isArray: true }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    IsUndefinable({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    IsNullable({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    IsArray({
        groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
        message: 'Define the specific stores for this campaign',
    }),
    ArrayNotEmpty({
        groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
        message: 'Define the specific stores for this campaign',
    }),
    IsUUIDWithLVS('4', {
        groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
        each: true,
        message: 'Define the specific stores for this campaign',
    }),
    __metadata("design:type", Array)
], ReadCampaignDto.prototype, "storeIds", void 0);
__decorate([
    ApiProperty({ description: 'List of config by workflow.', type: () => ReadCampaignWorkflowConfigDto, isArray: true }),
    Expose({
        groups: [
            CampaignExposeGroup.MODEL,
            CampaignExposeGroup.READ,
            CampaignExposeGroup.CREATE,
            CampaignExposeGroup.UPDATE,
            CampaignExposeGroup.CONFIG,
            CampaignExposeGroup.START,
        ],
    }),
    Type(() => ReadCampaignWorkflowConfigDto),
    IsUndefinable({ groups: [CampaignExposeGroup.UPDATE] }),
    IsArray({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    ValidateNested({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START], each: true }),
    __metadata("design:type", Array)
], ReadCampaignDto.prototype, "workflowDefinitions", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'State of campaign.', enum: CampaignStateEnum }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ],
    }),
    Allow({ always: true }),
    __metadata("design:type", String)
], ReadCampaignDto.prototype, "state", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Error status of campaign.', enum: CampaignStatusEnum }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ],
    }),
    Allow({ always: true }),
    __metadata("design:type", String)
], ReadCampaignDto.prototype, "status", void 0);
__decorate([
    ApiPropertyOptional({ description: 'DateTime when to start campaign.', format: 'date-time', type: () => String }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    TransformWithLVS(({ value }) => {
        return value instanceof Date ? value.toISOString() : value;
    }, { groups: [CampaignExposeGroup.READ] }),
    TransformWithLVS(({ value }) => {
        return typeof value == 'string' ? DateTime.fromISO(value, { zone: 'utc' }).toJSDate() : value;
    }, { groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    IsUndefinable({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE] }),
    IsNullable({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE] }),
    IsNotEmpty({ groups: [CampaignExposeGroup.START] }),
    IsDate({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    __metadata("design:type", String)
], ReadCampaignDto.prototype, "startAt", void 0);
__decorate([
    ApiPropertyOptional({ description: 'Start campaign immediately', type: () => Boolean }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", Boolean)
], ReadCampaignDto.prototype, "startImmediately", void 0);
__decorate([
    ApiPropertyOptional({ description: 'Intervals between campaign runner in days', example: 1, type: () => Number }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    IsUndefinable({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE] }),
    IsNotEmpty({ groups: [CampaignExposeGroup.START] }),
    IsNumber({ allowNaN: false, allowInfinity: false }, { groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    Min(1, { groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    __metadata("design:type", Number)
], ReadCampaignDto.prototype, "interval", void 0);
__decorate([
    ApiProperty({ description: 'DateTime of next run.', type: () => String, format: 'date-time' }),
    Expose({ groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ] }),
    TransformWithLVS(({ value }) => {
        return value instanceof Date ? value.toISOString() : value;
    }, { groups: [CampaignExposeGroup.READ] }),
    TransformWithLVS(({ value }) => {
        return typeof value == 'string' ? DateTime.fromISO(value).toJSDate() : value;
    }, { groups: [CampaignExposeGroup.MODEL] }),
    Allow({ always: true }),
    __metadata("design:type", String)
], ReadCampaignDto.prototype, "nextRunAt", void 0);
__decorate([
    ApiPropertyOptional({ description: 'DateTime of last campaign run.', type: () => String, format: 'date-time' }),
    Expose({ groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ] }),
    TransformWithLVS(({ value }) => {
        return value instanceof Date ? value.toISOString() : value;
    }, { groups: [CampaignExposeGroup.READ] }),
    TransformWithLVS(({ value }) => {
        return typeof value == 'string' ? DateTime.fromISO(value).toJSDate() : value;
    }, { groups: [CampaignExposeGroup.MODEL] }),
    Allow({ always: true }),
    __metadata("design:type", String)
], ReadCampaignDto.prototype, "lastRunAt", void 0);
__decorate([
    ApiProperty({ type: () => String, format: 'date-time' }),
    Expose({ groups: [CampaignExposeGroup.READ] }),
    TransformWithLVS(({ value }) => (value instanceof Date ? value.toISOString() : value), { groups: [CampaignExposeGroup.READ], toPlainOnly: true }),
    __metadata("design:type", String)
], ReadCampaignDto.prototype, "createdAt", void 0);
__decorate([
    ApiProperty({ type: () => String, format: 'date-time' }),
    Expose({ groups: [CampaignExposeGroup.READ] }),
    TransformWithLVS(({ value }) => (value instanceof Date ? value.toISOString() : value), { groups: [CampaignExposeGroup.READ], toPlainOnly: true }),
    __metadata("design:type", String)
], ReadCampaignDto.prototype, "updatedAt", void 0);
ReadCampaignDto = __decorate([
    ApiExtraModels(ReadCampaignCohortConfigDto, ReadCampaignWorkflowConfigDto)
], ReadCampaignDto);
export { ReadCampaignDto };
//# sourceMappingURL=ReadCampaignDto.js.map